
.input {
  width: 100%;
  all: unset;
  outline: revert;
  font: inherit;
  box-sizing: border-box;
  height: 2rem;
  outline: 0;
  padding: 0 1ch;
  border: 1px solid var(--static-divider-standard);
  background: var(--static-background-standard);
  border-radius: 8px;
}
.inputContainer:focus-within .inputOpen {
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.input:focus, input:hover {
  cursor: text;
}
input:disabled {
  cursor: not-allowed;
}

.inputContainer {
  width: 100%;
  color: var(--static-text-standard);
  margin: 0;
  position: relative;
  z-index: 2;
}

.hintContainer {
  display: none;
  position: absolute;
  top: 100%;
  width: 100%;
  background: var(--static-background-weak);
  border-left: 1px solid var(--static-divider-standard);
  border-right: 1px solid var(--static-divider-standard);
  border-bottom: 1px solid var(--static-divider-standard);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  min-height: 2rem;
  padding: 0 1ch;
  box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.08);
  z-index: 10;
}
.inputContainer:focus-within .hintContainer {
  display: flex;
}

.errorMessage {
  margin: 0.5rem;
  color: var(--static-text-weak);
  font-size: var(--fs-small);
}

.underlineArea {
  position: absolute;
}

.redSquiggles {
  align-self: flex-start;
  border-top: 2px solid var(--sentiment-text-negative);
  color: transparent;
  user-select: none;
  line-height: 0;
}

.pre {
  margin: 0;
  visibility: hidden;
}

.manualSearchAutocomplete {
  width: 30vw;
}

.inputGroup {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.inputLabelRow {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.paramRow {
  width: 100%;
}

.noShrink {
  min-width: max-content;
  white-space: nowrap;
  flex-shrink: 0;
}

.savedSearchSelect {
  width: min(50vw, 40rem); 
}

.savedSearch {
  width: 100%;
}

.savedSearchTopRow {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.savedSearchCode {
  display: inline;
  vertical-align: middle;
  font-family: monospace;
  font-size: var(--fs-small);
  color: var(--static-text-weak);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.savedSearchDescription {
  white-space: wrap;
}

.saveSearchModal {
  width: min(30rem, 30vw);
}